import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import Harvest from "../Harvest/Harvest.js";
import Bucking from "./Bucking.js";
import Trimming from "./Trimming.js";
import Inventory from "./Inventory.js";
import Quarantine from "./Quarantine.js";
import ReadyToPackage from "./ReadyToPackage.js";

const PostHarvestLogs = () => {
  const [contentTab, setContentTab] = useState(0);

  const tabsSx = {
    backgroundColor: "#fffffc",
    "& .MuiTabs-indicator": {
      backgroundColor: "#00A272",
      height: "3px",
    },
    "& .MuiTab-root": {
      position: "relative",
      color: "#A1A2A1",
      fontWeight: 400,
      fontSize: "16px",
      textTransform: "none",
      padding: "12px 20px",
      marginRight: "8px",
      "&:not(.Mui-selected)::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "3px",
        backgroundColor: "#C4C4C4",
      },
      "&.Mui-selected": {
        color: "#00A272 !important",
        fontWeight: 600,
        backgroundColor: "#E6F6F1",
        borderRadius: "4px 4px 0 0",
      },
    },
  };

  return (
    <div className="company">
      <div className="page-title">
        <div className="title-wrap">
          <h1>Post Harvest Logs</h1>
        </div>
      </div>

      <div className="common_content">
        <Tabs
          value={contentTab}
          onChange={(e, newValue) => setContentTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 3 }}
        >
          <Tab label="Harvest" />
          <Tab label="Bucking" />
          <Tab label="Trimming" />
          <Tab label="Inventory" />
          <Tab label="Quarantine" />
          <Tab label="Ready to Package" />
        </Tabs>

        {contentTab === 0 && <Harvest hideHeader={true} />}
        {contentTab === 1 && <Bucking />}
        {contentTab === 2 && <Trimming />}
        {contentTab === 3 && <Inventory />}
        {contentTab === 4 && <Quarantine />}
        {contentTab === 5 && <ReadyToPackage />}
      </div>
    </div>
  );
};

export default PostHarvestLogs;
